import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { fmtDate } from "../lib/format";

export default function SubscriptionBlocked() {
  const { user, logout } = useAuth();
  const org = user?.organizacion;
  const hasta = org?.vigente_hasta;

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-background p-8"
      data-testid="subscription-blocked"
    >
      <div className="max-w-md w-full bg-card border border-border rounded-md p-8 text-center">
        <h1 className="font-display text-xl font-medium text-foreground mb-2">
          Suscripción no vigente
        </h1>
        <p className="text-sm text-muted-foreground mb-4">
          El acceso a <strong>{org?.nombre || "su organización"}</strong> no está disponible.
          {hasta ? (
            <>
              {" "}
              La vigencia finalizó el <strong>{fmtDate(hasta)}</strong>.
            </>
          ) : (
            " La cuenta fue suspendida."
          )}
        </p>
        <p className="text-xs text-muted-foreground/70 mb-6">
          Contacte al administrador del sistema para renovar o reactivar su plan.
        </p>
        <button
          type="button"
          onClick={() => logout()}
          className="bg-primary hover:bg-success text-primary-foreground text-sm font-medium px-4 py-2 rounded-sm"
        >
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}
